import { render, staticRenderFns } from "./fileTab.vue?vue&type=template&id=8557a3dc&scoped=true&"
import script from "./fileTab.vue?vue&type=script&lang=ts&"
export * from "./fileTab.vue?vue&type=script&lang=ts&"
import style0 from "./fileTab.vue?vue&type=style&index=0&id=8557a3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8557a3dc",
  null
  
)

export default component.exports